/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessSocialMediaLinks.internal

import features.userBusinessSocialMediaLinks.models.SocialMediaLinksModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class UserBusinessSocialMediaLinksRequest : NetworkRequest() {

    suspend fun getUserBusinessSocialMediaLinks(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<SocialMediaLinksModel> {
        return safeNetworkCall {
            get(
                endpoint = UserBusinessSocialMediaLinksEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
